var modal = document.getElementById("myModal");
//var closeBtn = document.querySelector(".close");

function abrirModal() {
  modal.style.display = "flex";
  document.body.classList.add("no-scroll");
}

function esMobile() {
  return window.innerWidth <= 768;
}

function verificarHash() {
  if (window.location.hash === "#active" && esMobile()) {
    abrirModal();
  }
}

window.addEventListener("load", function (event) {
  verificarHash();
});

/*
closeBtn.onclick = function () {
  modal.style.display = "none";
  document.body.classList.remove("no-scroll");
};
*/

window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
    document.body.classList.remove("no-scroll");
  }
};
